import { StyledFormBlockWrapper } from '../../../Wrappers';
import { ContentWrapper, Header, HeaderTitle } from 'components/organisms/SettingsForm/styled';

import SkeletonLoader from '../../Skeleton';
import { ConfigBlock } from 'components/molecules/settings/styled';
import { InputDescription, InputTitle } from '../../../styleds';
import { Wrapper } from 'components/molecules/ChipsList/styled';

const SettingsMainFormLoader = () => {
  return (
    <StyledFormBlockWrapper
      as='form'
      desktopMl={0}
      style={{ minHeight: '100%', flexDirection: 'column' }}
    >
      <Header>
        <HeaderTitle><SkeletonLoader fullWidth={false} w='200px' height='30px' /></HeaderTitle>
        <div>
          <SkeletonLoader fullWidth={true} w='200px' height='50px' />
        </div>
      </Header>
      <ContentWrapper>
        <ConfigBlock>
          <InputTitle>
            <SkeletonLoader fullWidth={true} w='200px' height='24px' />
          </InputTitle>
          <InputDescription>
            <SkeletonLoader fullWidth={true} w='320px' height='36px' />
          </InputDescription>
          <Wrapper style={{ marginTop: 16 }} isColumn={true}>
            {[1,2,3].map(i => (
              <SkeletonLoader key={i} fullWidth={false} w='120px' height='30px' />
            ))}
          </Wrapper>
          <div style={{ marginTop: 20 }}>
            <InputTitle>
              <SkeletonLoader fullWidth={true} w='200px' height='24px' />
            </InputTitle>
            <InputDescription>
              <SkeletonLoader fullWidth={true} w='320px' height='36px' />
            </InputDescription>
          </div>
          <SkeletonLoader fullWidth={true} w='320px' height='44px' />
          <div style={{ marginTop: 40 }}>
            <InputDescription>
              <SkeletonLoader fullWidth={true} w='320px' height='36px' />
            </InputDescription>
          </div>
        </ConfigBlock>
      </ContentWrapper>
    </StyledFormBlockWrapper>
  );
};

export default SettingsMainFormLoader;
